import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { tap } from 'rxjs';
import { AfterGameService } from 'src/app/modules/games/services/after-game.service';

import { GamesLeaveBusterService } from '../services/games-leave-buster.service';

export const gamesLocalLeaveBusterGuard: CanActivateFn = () => {
    const leaveBusterService: GamesLeaveBusterService = inject(GamesLeaveBusterService);
    const afterGameService: AfterGameService = inject(AfterGameService);

    if (leaveBusterService.isAllowedToLeaveLocalGame()) {
        if (!leaveBusterService.gameIsFinished) {
            afterGameService.cleanupAfterLocalGame();
        }

        return true;
    } else {
        return leaveBusterService.startLocalLeaveProcess().pipe(
            tap((hasLeft) => {
                if (hasLeft) {
                    afterGameService.cleanupAfterLocalGame();
                }
            })
        );
    }
};
